module.exports = __webpack_public_path__ + "static/img/大雨转暴雨.a6f8e8b9.svg";